<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  [start]="startStage"
  [end]="endStage"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div class="w-title">
    <app-ion-common-label
      [id]="idLabelIncome"
      class="document-type-label1 w-title"
      labelStyle="display-rg"
      labelDescription="Qual é a sua renda mensal?"
    >
    </app-ion-common-label>
  </div>
  <p [id]="idMessageIncome" class="info-page">
    Estes dados são uma exigência dos órgãos reguladores, necessários para o seu
    cadastro e protegidos por sigilo bancário.
  </p>

  <div class="conent-center">
    <form ngForm (ngSubmit)="submitForm($event)">
      <app-ion-common-input-currency
        [id]="idInputCurrencyIncome"
        [label]="'Renda e patrimônio'"
        [placeholder]="placeholder"
        [inputTextValue]="inputTextValue"
        (sendValueInput)="setInputTextValue($event)"
        [disabled]="!this.edit"
      >
      </app-ion-common-input-currency>
    </form>
  </div>
  <app-ion-common-button
    [id]="idButtonIncome"
    class="hidden"
    [ngClass]="{'hidden': !verifyStatusBtn()}"
    [attr.aria-hidden]="!verifyStatusBtn()"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>
